module.exports = __webpack_public_path__ + "static/img/Store-8.577245fd.png";